module.exports = __webpack_public_path__ + "img/background029.jpg";